import React, { useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import { Avatar, Box, styled, Container, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAuth } from '../../../hooks/useAuth';
import { register, auth } from '../../../services/user-services';
import RegisteryAccount from './registery-main';
import logo from '../../../assets/logo.ico'


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

function Register() {
    
    const [username, setUserName ] = useState('')
    const [last_name, setLastName ] = useState('')
    
    const [password, setPassword ] = useState('')
    const [password2, setPassword2 ] = useState('')
    const [email, setEmail ] = useState('')

    const { setAuth, authDataLang } = useAuth()
    const navigate = useNavigate()

    const passMatch = () => {
        return password === password2
    }

    const handelSubmit = async e => {
        e.preventDefault()
        if (passMatch) {
            const regData = await register({last_name, username, email, password, profile:{is_permium: false}})
            if (regData) {
                // console.log(regData)
                const data = await auth({username, password})
                setAuth(data)
                navigate('/account')
            }
        }
        // const data = await auth({username, password});
        // setAuth(data);
      }
    
  return (
    <React.Fragment>
        <Box elevation={2} sx={{  
            bgcolor: 'background.paper', 
            minHeight: 1000,
            margin: '0.5rem 1rem 0.5rem 0.5rem' }}
            textAlign={'center'}
            >
            <div style={{textAlign: 'center'}}>
                <Grid container alignItems='flex-end'>
                    <Grid item xs={12} >
                        <Avatar 
                            src={logo}
                            sx={{display: 'block', 
                                textAlign: 'center', 
                                marginLeft: 'auto', 
                                marginRight: 'auto',
                                width:120, height:120
                            }}
                            alt="logo tekno" 
                            />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            component="div"
                            variant="h4"
                            color="primary"
                            fontFamily={'iran1'}
                            textAlign={'center'}
                            >
                            {authDataLang?.site_langs?.desc_register}
                        </Typography>    
                    </Grid>
                </Grid>               

            </div>

            <Paper elevation={3}>
                <form onSubmit={handelSubmit}>
                    <Container maxWidth="sm" >
                        <Item>
                            <div style={{textAlign: 'left'}}>
                                    <RegisteryAccount/>
                            </div>
                        </Item>
                    </Container>
                </form>
            </Paper>
        </Box>
    
    </React.Fragment>
  );
}

export default Register;
